import { render, staticRenderFns } from "./GenericPage.vue.js?vue&type=template&id=c976dba4&scoped=true!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./GenericPage.vue?vue&type=template&id=c976dba4&scoped=true"
import script from "./GenericPage.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./GenericPage.vue?vue&type=script&lang=js"
export * from "./GenericPage.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./GenericPage.vue?vue&type=script&lang=js"
import style0 from "./GenericPage.vue.scss?vue&type=style&index=0&id=c976dba4&prod&scoped=true&lang=scss!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./GenericPage.vue?vue&type=style&index=0&id=c976dba4&prod&scoped=true&lang=scss"
import style1 from "./GenericPage.vue.scss?vue&type=style&index=1&id=c976dba4&prod&lang=scss!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./GenericPage.vue?vue&type=style&index=1&id=c976dba4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c976dba4",
  null
  
)

export default component.exports